export default __webpack_public_path__ + "static/media/learner.cbf2f6dd.png";